import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'byGender',
  pure: false,
  standalone: false
})
export class ByGenderPipe implements PipeTransform {
  public transform(items: any[], value: any): any[] {
    return value === null ? items : items.filter((item) => item.GenderId === value);
  }
}
